import { AbyssTheme as themeConfiguration } from '@src/app/browser';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { config } from '@uhg-abyss/web/tools/config';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Link } from '@uhg-abyss/web/ui/Link';
import { Modal } from '@uhg-abyss/web/ui/Modal';
import { isEmpty } from 'lodash';
import React from 'react';

/**
 * AssociatedEids
 *
 * Displays associated EID's in a modal with a link to HCM.
 *
 * @param associatedEids
 * @param isOpen
 * @param setIsOpen
 * @returns {Element}
 * @constructor
 */
export function AssociatedEids({ associatedEids = [], isOpen = false, setIsOpen = () => {} }) {
  return (
    <ErrorHandler location="src/pages/private/Analysis/EidSearch/components/Details/components/AssociatedEids/AssociatedEids.jsx">
      <Modal
        isOpen={isOpen}
        onClose={() => {
          setIsOpen(false);
        }}
        title="Associated EID's"
      >
        <Modal.Section>
          <Layout.Stack
            alignItems="left"
            alignLayout="left"
            grow
            space={Number(themeConfiguration?.theme?.space?.xs) || 4}
          >
            {!isEmpty(associatedEids) &&
              associatedEids.map((associatedEid) => {
                return (
                  <Link href={`${config('HCM_URL')}/${associatedEid}/`} key={associatedEid} openNewWindow>
                    {associatedEid}
                  </Link>
                );
              })}
          </Layout.Stack>
        </Modal.Section>
      </Modal>
    </ErrorHandler>
  );
}
